module.exports = __webpack_public_path__ + "img/refresh.cadaa134.svg";